export const REACH_SUPPORT_URL =
  'https://support.fountain.com/en/articles/9899478-fountain-reach';
